module.exports = __webpack_public_path__ + "img/feature2.021efba8.png";